// src/services/collaboratorStore.ts
import { encrypt, decrypt } from "../services/secureStorage";

const FIELD = "__kiosko_last_collaborator__";

type Stored = { data: string };

export async function setEncryptedCollaborator<T>(value: T): Promise<void> {
  const enc = await encrypt(value);
  localStorage.setItem(FIELD, JSON.stringify(enc));
}

export async function getEncryptedCollaborator<T>(): Promise<T | null> {
  const raw = localStorage.getItem(FIELD);
  if (!raw) return null;
  const parsed = JSON.parse(raw) as Stored;
  return decrypt<T>(parsed);
}

export function clearEncryptedCollaborator(): void {
  localStorage.removeItem(FIELD);
}
